export { default } from './toPairs.js'



//////////////////
// WEBPACK FOOTER
// ./node_modules/lodash-es/entries.js
// module id = 397
// module chunks = 0